export const navMenus = [
  {
  label : 'HOME',
  to : '/'
},
  {
  label : 'ABOUT ME',
  to : '/about'
},
  {
  label : 'SKILLS',
  to : '/skills'
},
  {
  label : 'RESUME',
  to : '/resume'
},
  {
  label : 'PORTFOLIO',
  to : '/portfolio'
},
  {
  label : 'CONTACT',
  to : '/contact'
}
]